// extracted by mini-css-extract-plugin
export default {"isSaved":"gGjaA___AddToSavedItemsButton-module__isSaved"};